import { h } from "preact";
import cn from "classnames";
import s from "../Mint/style.css";

export default function ({ account, connect, class: className }) {
  if (!account)
    return (
      <button
        type="button"
        class={cn(s.buttonMint, className)}
        onClick={connect}
      >
        Connect
      </button>
    );

  return (
    <button class={cn(s.buttonMint, className)}>
      {account.substring(0, 4)}...{account.substring(account.length - 4)}
    </button>
  );
}
